module.exports = __webpack_public_path__ + "img/f2f.a890d884.svg";